var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { isPresent } from '../../utils';
var RADIO_ATTRIBUTES = {
    type: 'radio',
    name: 'day',
    className: 'k-radio'
};
var DEFAULT_OFFSET = 1;
var getOffset = function (rrule) {
    if (isPresent(rrule.byWeekDay)) {
        var weekDaysCount = rrule.byWeekDay.length;
        switch (weekDaysCount) {
            case 7:
            case 5:
            case 2:
                return rrule.bySetPosition[0];
            case 1:
                return rrule.byWeekDay[0].offset;
            default:
                break;
        }
    }
    return DEFAULT_OFFSET;
};
var getWeekDay = function (rrule, start) {
    if (isPresent(rrule.byWeekDay)) {
        var weekDaysCount = rrule.byWeekDay.length;
        switch (weekDaysCount) {
            case 7:
                return 'day';
            case 5:
                return 'weekday';
            case 2:
                return 'weekend';
            case 1:
                return rrule.byWeekDay[0].day;
            default:
                break;
        }
    }
    return start.getDay();
};
/** @hidden */
export var RecurrenceRepeatOnMonthYearEditor = function (props) {
    var titleMonthly = props.titleMonthly, titleYearly = props.titleYearly, titleClassName = props.titleClassName, editorClassName = props.editorClassName, monthlyDayTitle = props.monthlyDayTitle, start = props.start, repeatOnRule = props.repeatOnRule, frequency = props.frequency, rrule = props.rrule, months = props.months, offsetPositions = props.offsetPositions, extendedWeekDays = props.extendedWeekDays, yearlyOf = props.yearlyOf, onRepeatOnRuleChange = props.onRepeatOnRuleChange, onMonthDaysChange = props.onMonthDaysChange, onMonthsChange = props.onMonthsChange, onOffsetPositionChange = props.onOffsetPositionChange, onWeekDayChange = props.onWeekDayChange;
    var month = frequency === 'yearly' && rrule.byMonth ? months.find(function (item) { return rrule.byMonth[0] === item.value; }) : null;
    var offset = getOffset(rrule);
    var currentOffset = offsetPositions.find(function (item) { return offset === item.value; });
    var weekDay = getWeekDay(rrule, start);
    var currentWeekDay = extendedWeekDays.find(function (item) { return item.value === weekDay; });
    var isDisabled = React.useCallback(function (currentRepeatOnRule) {
        return repeatOnRule !== currentRepeatOnRule;
    }, [repeatOnRule]);
    var onRepeatOnRuleChangeHandler = React.useCallback(function (e) {
        onRepeatOnRuleChange(e.target.value, weekDay, offset);
    }, [onRepeatOnRuleChange]);
    var onMonthDaysChangeHandler = React.useCallback(function (e) {
        onMonthDaysChange([e.value]);
    }, [onMonthDaysChange]);
    var onMonthsChangeHandler = React.useCallback(function (e) {
        var selectedMonth = e.target.value;
        var valueField = e.target.props.dataItemKey;
        onMonthsChange([selectedMonth[valueField]]);
    }, [onMonthsChange]);
    var onOffsetPositionChangeHandler = React.useCallback(function (e) {
        var selectedOffsetPostion = e.target.value;
        var valueField = e.target.props.dataItemKey;
        onOffsetPositionChange(selectedOffsetPostion[valueField]);
    }, [onOffsetPositionChange]);
    var onWeekDayChangeHandler = React.useCallback(function (e) {
        var selectedWeekDay = e.target.value;
        var valueField = e.target.props.dataItemKey;
        onWeekDayChange(selectedWeekDay[valueField], offset);
    }, [onWeekDayChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: titleClassName }, frequency === 'yearly' ? titleYearly : titleMonthly),
        React.createElement("div", { className: editorClassName },
            React.createElement("ul", { className: 'k-reset' },
                React.createElement("li", null,
                    React.createElement("input", __assign({}, RADIO_ATTRIBUTES, { checked: repeatOnRule === 'monthday', id: 'k-repeaton-monthday', onChange: onRepeatOnRuleChangeHandler, value: 'monthday' })),
                    React.createElement("label", { className: 'k-radio-label', htmlFor: 'k-repeaton-monthday' }, frequency === 'monthly' && monthlyDayTitle),
                    frequency === 'yearly' && (React.createElement(React.Fragment, null,
                        React.createElement(DropDownList, { textField: 'text', dataItemKey: 'value', data: months, style: { width: 'auto' }, value: month, onChange: onMonthsChangeHandler, disabled: isDisabled('monthday') }),
                        "\u00A0")),
                    React.createElement(NumericTextBox, { width: 'auto', min: 1, max: 31, disabled: isDisabled('monthday'), value: props.monthDay, onChange: onMonthDaysChangeHandler })),
                React.createElement("li", null,
                    React.createElement("input", __assign({}, RADIO_ATTRIBUTES, { checked: repeatOnRule === 'weekday', id: 'k-repeaton-weekday', onChange: onRepeatOnRuleChangeHandler, value: 'weekday' })),
                    React.createElement("label", { className: 'k-radio-label', htmlFor: 'k-repeaton-weekday' }),
                    React.createElement(DropDownList, { textField: 'text', dataItemKey: 'value', data: offsetPositions, style: { width: 'auto' }, value: currentOffset, onChange: onOffsetPositionChangeHandler, disabled: isDisabled('weekday') }),
                    "\u00A0",
                    React.createElement(DropDownList, { textField: 'text', dataItemKey: 'value', data: extendedWeekDays, style: { width: 'auto' }, value: currentWeekDay, disabled: isDisabled('weekday'), onChange: onWeekDayChangeHandler }),
                    "\u00A0",
                    frequency === 'yearly' && (React.createElement("span", null,
                        yearlyOf,
                        "\u00A0")),
                    frequency === 'yearly' && (React.createElement(DropDownList, { textField: 'text', dataItemKey: 'value', data: months, style: { width: 'auto' }, value: month, disabled: isDisabled('weekday'), onChange: onMonthsChangeHandler })))))));
};
//# sourceMappingURL=RecurrenceRepeatOnMonthYearEditor.js.map